module.exports = __webpack_public_path__ + "methods-map.svg";